import { apiClient } from "./apiClient"

/****************************************************************************
 * 
 * Devices
 * 
 ***************************************************************************/

export const deviceApi = {
    /**
     * Fetch Device List for a given Business Entity ID
     * @param {string} businessEntityId - The Business Entity ID
     * @param {object} filters - Any filters that need to be applied to data
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The UTG list as a Promise
     */
    fetchDeviceList: async (businessEntityId, filters, config, accessToken, signal=null) => {
        const componentsFilter = filters ? JSON.stringify(filters) : '{"Predicates": []}'
        const body = JSON.stringify(componentsFilter).replace("\n", "")
        return await apiClient(
            `${config.managementApiUrl}/businessentities/${businessEntityId}/devices/query`,
            accessToken,
            {
                method: 'POST',
                body: body,
                headers: {
                    'Clientid': 4
                }
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.deviceView
                    }
                )
            },
            signal
        )
    },
    /**
     * Export Devices List
     * @param {string} businessEntityId - The Business Entity ID
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    exportDeviceList: async (businessEntityId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/devices/query/csv`
        const tasksFilter = '{"Predicates": []}'
        const body = JSON.stringify(tasksFilter).replace("\n", "")
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body: body
            },
            async (response) => {
                return await response.arrayBuffer()
            }
        )
    }
}